<template>
  <BaseTableView
    :class="extra && $vuetify.breakpoint.xlOnly ? 'table--extra' : ''"
    :head="tableHeadCurrent"
    :sticky="false"
  >
    <template v-for="(item, key) in work">
      <TimeControlShowEmployeeDayTableItem
        :item="item"
        :key="key"
        :extra="extra"
        :edit="edit"
        :functionUpdate="functionUpdate"
        :showHoursColumn="showHoursColumn"
      />
      <tr :key="'images_block_' + key" class="tr_no_hover">
        <td
          :colspan="tableColspan"
          class="images_grid_item"
          :style="imagesGridStyle"
        >
          <div class="pa-2 grid_cards gap5">
            <BaseCard
              :subtitle="localStorage.translations.pages['statistic_employee'].tables['fotografii']"
              hidden-data
              :disabled-hidden-data="!(item.data && item.data.images && item.data.images.length)"
              class="flex-grow-1"
            >
              <UploadFile
                slot="action"
                :accept="['jpg', 'jpeg', 'png']"
                :on-load="onLoadNewImage"
                :external-data="{id: key, extra: extra}"
                :disabled="edit"
              />
              <TimeControlShowEmployeeDayGalleryV2
                v-if="item.data && item.data.images && item.data.images.length"
                :files="item.data.images"
                :disabled="edit"
                :external-data="{id: key, extra: extra, scheme: false}"
                :on-change="onChangeImages"
              />
            </BaseCard>
            <BaseCard
              v-if="item.data && item.data['scheme_image'] && item.data['scheme_image'].length"
              :subtitle="localStorage.translations.pages['statistic_employee'].tables['chertezhi']"
              hidden-data
            >
              <TimeControlShowEmployeeDayGalleryV2
                :files="item.data['scheme_image']"
                :disabled="edit"
                :external-data="{id: key, extra: extra, scheme: true}"
                :on-change="onChangeImages"
              />
            </BaseCard>
          </div>
        </td>
      </tr>
    </template>
  </BaseTableView>
</template>

<script>
import TimeControlShowEmployeeDayTableItem
  from 'components/timeControl/showEmployee/day/TimeControlShowEmployeeDayTableItem'
import TimeControlShowEmployeeDayGalleryV2
  from "components/timeControl/showEmployee/day/TimeControlShowEmployeeDayGalleryV2";
import UploadFile from "components/UploadFile";
import {mapActions} from "vuex";

export default {
  name: 'TimeControlShowEmployeeDayTable',
  props: {
    work: Array, index: Number, extra: Boolean, edit: Boolean, functionUpdate: Function, reportId: [Number, String]
  },
  components: {
    UploadFile,
    TimeControlShowEmployeeDayGalleryV2,
    TimeControlShowEmployeeDayTableItem,
  },
  computed: {
    showHoursColumn() {
      return (
        !this.extra &&
        Array.isArray(this.work) &&
        this.work.some((item) => item?.work_type?.is_hourly == 0)
      )
    },
    tableHeadCurrent() {
      if (this.extra) return this.tableHeadExtra
      return this.showHoursColumn ? this.tableHeadWithHours : this.tableHead
    },
    tableColspan() {
      return this.tableHeadCurrent.length
    },
    imagesGridStyle() {
      return { gridColumn: '1 / -1' }
    },
    tableHead() {
      return [
        {text: this.localStorage.translations.pages['statistic_employee'].tables['vid-rabot']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['fakt']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['chasy']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['primechanie']},
        {text: this.localStorage.translations.pages.common.text['block'] || 'Block'},
        {active: true},
      ]
    },
    tableHeadWithHours() {
      return [
        {text: this.localStorage.translations.pages['statistic_employee'].tables['vid-rabot']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['fakt']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['chasy']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['primechanie']},
        {text: this.localStorage.translations.pages.common.text['block'] || 'Block'},
        {active: true},
      ]
    },
    tableHeadExtra() {
      return [
        {text: this.localStorage.translations.pages['statistic_employee'].tables['dopolnitelnaya-rabota']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['chasy']},
        {text: this.localStorage.translations.pages['statistic_employee'].tables['primechanie']},
        {text: this.localStorage.translations.pages.common.text['block'] || 'Block'},
        {active: true},
      ]
    },
  },
  methods: {
    ...mapActions('employeeWorkDay', ['onEmployeeWorkDay_periodReport_post', 'onEmployeeWorkDay_extra_update']),
    ...mapActions(['deleteFile']),

    async onSaveChanges(external) {
      if (external.extra) {
        let data = {
          id: this.work[external.id].id,
          data: JSON.stringify(this.work[external.id].data)
        }
        await this.onEmployeeWorkDay_extra_update(data)
      } else {
        let data = {
          employee_id: this.$route.params.employeeId,
          employee_work_day_id: this.reportId,
          data: JSON.stringify(this.work[external.id].data),
          employee_period_id: this.work[external.id].employee_period_id
        }
        await this.onEmployeeWorkDay_periodReport_post(data)
      }
    },

    async onLoadNewImage(files, external) {
      if (!this.work[external.id].data) {
        this.work[external.id].data = {images: files.map(i => i.url), scheme_image: []}
      } else {
        if (!this.work[external.id].data.images) this.work[external.id].data.images = []
        this.work[external.id].data.images.push(...files.map(i => i.url))
      }
      await this.onSaveChanges(external)
    },

    async onChangeImages(files, external) {
      if (external.scheme) {
        this.work[external.id].data.scheme_image = files
        await this.deleteFile({url: external.onDelete})
      } else {
        this.work[external.id].data.images = files
        await this.deleteFile({url: external.onDelete})
      }
      await this.onSaveChanges(external)
    }
  }
}
</script>

<style lang="scss" scoped>
.images_grid_item {
  grid-column-start: 1;

  &:before {
    content: none;
  }
}

.d-flex, .fill-width {
  width: 100%;
}

.grid_cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  align-items: start;
  width: 100%;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
  }
}

.tr_no_hover {
  background-color: #f2f2f2 !important;

  &:hover {
    background-color: #f2f2f2 !important;
  }

  td {
    grid-column: 1 / -1;
  }
}
</style>
